import { ContactListItemProps } from "../types"
import React from "react"
import { StyleSheet } from "~/ui/primitives"
import { useTheme } from '~/ui/styled'
import { StartFlex, ColumnFlex, BetweenFlex, IconFont, Button, Text } from "~components/El"
import { Avatar } from "~widgets/avatar"

const BlackListCartItem: React.FC<ContactListItemProps> = ({
  contact,
  isSelectMode,
  isLastItem,
  selecteds,
  onItemClick,
}) => {
  const theme = useTheme()
  const checked = selecteds?.find(i => i.user_id === contact.user_id)
  return (
    <StartFlex width="100%">
      <Button
        flexDirection="row"
        width="100%"
        padding="0 12px"
        bg={theme.colors.blockBackground}
        onClick={() => onItemClick?.(contact)}
      >
        <Avatar size={40} avatar={contact.user.avatar} name={contact.displayName} />
          <BetweenFlex
            flex={1}
            padding="22px 0"
            ml="10px"
            style={{
              borderBottomWidth: StyleSheet.hairlineWidth,
              borderBottomColor: isLastItem ? "transparent" : theme.colors.border,
              borderBottomStyle: "solid"
            }}
          >
            <ColumnFlex>
              <Text color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600" mb="3px">{contact.displayName}</Text>
              <Text color={theme.colors.secondary} fontSize={theme.fontSizes.sm} fontWeight="400" mb="3px">点击添加到黑名单</Text>
            </ColumnFlex>
            {isSelectMode && <IconFont name={checked ? "cg" : "yuan"} size={15} color={checked ? theme.colors.primary : theme.colors.border} />}
          </BetweenFlex>
      </Button>
    </StartFlex>
  )
}

export default BlackListCartItem
